import { Ticket } from '../../types/ticket';
import { Rule } from '../types/Rule';
import { RuleContext } from '../types/RuleContext';

export class ConcatStatusSessionInDateTicketRule implements Rule {
  apply(context: RuleContext): Ticket[] {
    const { event, tickets } = context;

    if (!event) return tickets;

    return tickets.map((ticket) => ({
      ...ticket,
      type : ticket.type.map((type) => ({
        ...type,
        dates : type.dates.map((date) => {
          const session = event.sessions.find((session) => session.id === date.id)!;
          return {
            ...date,
            status : session?.status
          };
        })
      }))
    }));
  }
}
